import { ACCOUNT_ROUTES } from 'App/constants'
import { operationFetchUser } from 'App/duck/operations'
import history from 'App/history'

import klarnaPaymentsAuthorize from '../helpers/klarnaPaymentsAuthorize'
import klarnaPaymentsInitialize from '../helpers/klarnaPaymentsInitialize'
import { initStoreActivation, performStoreActivation, fetchStoreActivationInfo } from '../requests'
import {
  trackOmniJoinInitiate,
  trackOmniJoinSuccess,
  trackOmniJoinTechnicalError,
  trackOmniJoinKlarnaAuthDeclined,
} from '../tracking'
import { MemberInfo } from '../types'
import {
  setMemberInfo,
  setPaymentsInitStart,
  setPaymentsInitSuccess,
  setPaymentsInitFail,
  setPaymentsAuthStart,
  setPaymentsAuthStatus,
  fetchStoreActivationSessionStart,
  fetchStoreActivationSessionSuccess,
  storeActivationFail,
  fetchStoreActivationInfoStart,
  fetchStoreActivationInfoSuccess,
  fetchStoreActivationInfoFail,
} from './actions'
import { normalizeStoreActivationSession, normalizeStoreActivationInfo } from './normalize'
import selectors from './selectors'

export const operationFetchStoreActivationSession = () => async (dispatch) => {
  dispatch(fetchStoreActivationSessionStart())

  try {
    const storeActivationSessionData = await initStoreActivation()

    const { clientToken, klarnaSessionBody, paymentMethodCategory } =
      normalizeStoreActivationSession(storeActivationSessionData)

    if (clientToken) {
      dispatch(setPaymentsInitStart())

      const [klarnaInitLoaded, klarnaInitError] = await klarnaPaymentsInitialize(clientToken)

      if (klarnaInitLoaded && !klarnaInitError) {
        dispatch(setPaymentsInitSuccess())
        dispatch(fetchStoreActivationSessionSuccess({ klarnaSessionBody, paymentMethodCategory }))
      } else {
        dispatch(setPaymentsInitFail())
        dispatch(storeActivationFail({ error: klarnaInitError }))
      }
    }
  } catch (error) {
    dispatch(storeActivationFail({ error }))
  }
}

export const operationPerformStoreActivation = () => async (dispatch, getState) => {
  try {
    dispatch(setPaymentsAuthStart())
    const state = getState()
    const klarnaSessionBody = selectors.getStoreActivationSessionBody(state)
    const paymentMethodCategory = selectors.getStoreActivationPaymentMethodCategory(state)

    trackOmniJoinInitiate()

    const klarnaAuthResponse = await klarnaPaymentsAuthorize(
      paymentMethodCategory,
      klarnaSessionBody,
    )

    const { authorizationToken, approved, showForm } = klarnaAuthResponse
    dispatch(
      setPaymentsAuthStatus({
        paymentMethodCategory,
        response: klarnaAuthResponse,
      }),
    )
    if (approved && authorizationToken) {
      await performStoreActivation(authorizationToken)
      dispatch(operationFetchUser())
      trackOmniJoinSuccess()
      history.push(`${ACCOUNT_ROUTES.AccountOverview.path}?klarnaOptedIn=true`)
    } else if (showForm === false) {
      trackOmniJoinKlarnaAuthDeclined()
      history.push(ACCOUNT_ROUTES.AccountOverview.path)
    }
  } catch (error) {
    trackOmniJoinTechnicalError()
    dispatch(storeActivationFail({ error }))
  }
}

export const operationFetchStoreActivationInfo = () => (dispatch) => {
  dispatch(fetchStoreActivationInfoStart())

  fetchStoreActivationInfo()
    .then((data) => {
      dispatch(fetchStoreActivationInfoSuccess(normalizeStoreActivationInfo(data)))
    })
    .catch((error) => dispatch(fetchStoreActivationInfoFail(error)))
}

export const operationSetMemberInfo = (memberInfo: MemberInfo) => async (dispatch) => {
  dispatch(setMemberInfo(memberInfo))
}
